import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";


import Hero from "components/hero/TwoColumnWithFeaturesAndTestimonial.js";
import Features from "components/features/ThreeColWithSideImage.js";
import MainFeature from "components/features/TwoColWithTwoHorizontalFeaturesAndButton.js";
import FeatureStats from "components/features/ThreeColCenteredStatsPrimaryBackground.js";
import Pricing from "components/pricing/TwoPlansWithDurationSwitcher.js";
import Blog from "components/blogs/GridWithFeaturedPost.js";
import Testimonial from "components/testimonials/TwoColumnWithImageAndRating.js";
import FAQ from "components/faqs/SingleCol.js";
import GetStarted from "components/cta/GetStartedLight.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import VerticalWithAlternateImageAndTextServices from "components/features/VerticalWithAlternateImageAndTextServices";
import { Helmet } from "react-helmet-async";

const HighlightedText = tw.span`text-pbsGreen-500`

export default () => {
  return (
    <>
    <Helmet>
      <title>Services | Placement & Business Services Ltd</title>
      <meta
        name="description"
        content="Explore our range of services designed to meet your needs."
      />

      <link rel="canonical" href="https://www.pbslja.com/services" />

      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ServicesPage",
          "name": "Services",
          "url": "https://www.pbslja.com/services",
          "description": "Explore the range of services provided by Placement and Business Services Ltd., including recruitment, HR solutions, and business support.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.pbslja.com/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Services",
                "item": "https://www.pbslja.com/services"
              }
            ]
          }
        })}
      </script>
    </Helmet>
    <AnimationRevealPage>
      <Hero />
      {/* <FeatureStats/> */}
      {/* <Features 
        heading={<>Amazing <HighlightedText>Features</HighlightedText></>}
      /> */}
      <VerticalWithAlternateImageAndTextServices></VerticalWithAlternateImageAndTextServices>
      {/* <MainFeature
        heading={<>Cloud built by and for <HighlightedText>Professionals</HighlightedText></>}
      />
      <Testimonial 
        heading={<>Our Clients <HighlightedText>Love Us</HighlightedText></>}
      />
      <Pricing 
        heading={<>Flexible <HighlightedText>Plans</HighlightedText></>}
      />
      <FAQ
        heading={<>Any <HighlightedText>Questions ?</HighlightedText></>}
      />
      <Blog
        subheading="Blog"
        heading={<>We love <HighlightedText>Writing</HighlightedText></>}
      /> */}
      <GetStarted/>
      <Footer />
    </AnimationRevealPage>
    </>
  );
}
